import { render, staticRenderFns } from "./ComparePage.vue?vue&type=template&id=240c6535&scoped=true&"
import script from "./ComparePage.vue?vue&type=script&lang=js&"
export * from "./ComparePage.vue?vue&type=script&lang=js&"
import style0 from "./ComparePage.vue?vue&type=style&index=0&id=240c6535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240c6535",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
